import { Tag } from 'antd'

export default function TagOrgCustom({ orgData }) {
  if (!orgData) return null

  return (
    <Tag
      className="me-0"
      style={{
        backgroundColor: orgData.colorBgPrimary,
        color: orgData.colorTextPrimary,
        border: 0,
        fontWeight: 500,
        fontSize: '12px',
        height: 22,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 12,
        padding: '0 12px',
      }}
    >
      {orgData.orgShortCode}
    </Tag>
  )
}